module.exports = __webpack_public_path__ + "img/kehu_lvcheng.535d17e6.png";